import { DesigntimeComponent } from './DesigntimeComponent.js'
import componentHelpers from './componentHelpers.js'
import { LiquidString } from '../common/LiquidString.js'
import * as $ from 'jquery';

class BinaryVertical extends DesigntimeComponent {
    static staticName = "2 Buttons vertically (true/false)";
    static staticId = "binaryVertical";
    runtimeValue = null;

    constructor(identifyer) {
        super(identifyer, 1);

        this.disableNextButton();

        this.values = {
            text: new LiquidString("text", `${this.id}_text`),
            trueText: { value: "Yes" },
            falseText: { value: "No" },
            buttontext: { value: "Next" },
            nextOnClick: { value: "false", dontTranslate: true, description: "Set to 'true' if next component should be shown without next-button click" }
        };
    }

    getRuntimeView(context) {
        if (context.params.useBootstrapUi)
            return this.getRuntimeBootstrapView();

        let $view = $("<div class='sid-clearfix'></div>");

        let $text = $("<div class='sid-question-text'></div>");
        $text.append($("<h3>" + this.values.text.value + "<h3>"));
        $view.append($text);

        let $trueButton = $("<div class='sid-column-button'>" + this.values.trueText.value + "</div>");
        $trueButton.click(function (e) {
            this.runtimeValue = true;
            $(e.currentTarget).parent().find(".sid-button-selected").removeClass("sid-button-selected");
            $(e.currentTarget).addClass("sid-button-selected");
            this.enableNextButton();
        }.bind(this));
        $view.append($trueButton);

        let $falseButton = $("<div class='sid-column-button'>" + this.values.falseText.value + "</div>");
        $falseButton.click(function (e) {
            this.runtimeValue = false;
            $(e.currentTarget).parent().find(".sid-button-selected").removeClass("sid-button-selected");
            $(e.currentTarget).addClass("sid-button-selected");
            this.enableNextButton();
        }.bind(this));
        $view.append($falseButton);

        return $view;
    }

    getRuntimeBootstrapView() {

        let $view = $("<div class='vstack gap-1 mb-4 content-binary-buttons'></div>");

        $view.append(this.values.text.getTag("h3"));

        let buttonclasses = componentHelpers.getButtonClasses();

        let $trueButton = $(`<button class='${buttonclasses}'>${this.values.trueText.value}</button>`);
        if (this.values.nextOnClick.value == "true")
            $trueButton.addClass("internal-next-button");
        $trueButton.on("click", function (e) {
            this.runtimeValue = true;
            $(e.currentTarget).parent().find(".active").removeClass("active");
            $(e.currentTarget).addClass("active");
            this.enableNextButton();
        }.bind(this));
        $view.append($trueButton);

        let $falseButton = $(`<button class='${buttonclasses}'>${this.values.falseText.value}</button>`);
        if (this.values.nextOnClick.value == "true")
            $falseButton.addClass("internal-next-button");
        $falseButton.on("click", function (e) {
            this.runtimeValue = false;
            $(e.currentTarget).parent().find(".active").removeClass("active");
            $(e.currentTarget).addClass("active");
            this.enableNextButton();
        }.bind(this));
        $view.append($falseButton);

        return $view;
    }

    getOutput() {
        return {
            value: this.runtimeValue,
            not_value: !this.runtimeValue
        };
    }

    output = [
        { name: "value", type: "bool" },
        { name: "not_value", type: "bool" }
    ];
}

export { BinaryVertical }
